module.exports = __webpack_public_path__ + "static/media/data.37409cee.png";